import * as appStudioUtils from '../appStudio';

const isNewWorkspaceEnabled = (): boolean =>
  !appStudioUtils.isAppStudio() && !(window as any).isResponsive;

const isNewWorkspaceFTETourEnabled = (): boolean => isNewWorkspaceEnabled();
// && experiment.isOpen('se_newWorkspace_firstTimeExperienceTour');

export { isNewWorkspaceEnabled, isNewWorkspaceFTETourEnabled };
